export default "__VITE_ASSET__CHFZs4t___"